import usePrefix from '@/hooks/usePrefix';
import React from 'react';
import { ControlLabel, FormGroup } from 'rsuite';
import { getConcatCity } from '@/components/utils';
import { Cascader } from '@/components/Bicester';
import { FormControl } from '@/components/formik-rsuite';
import PageLoader from '@/components/shared/PageLoader';
import useAllCities from '@/hooks/preload/useAllCities';
import { FORM_DEFAULT_DISPLAY } from '@/constants/config';

const BicesterCardCityPicker = ({
  isEdit = true,
  notEditable = false,
  required = false,
  label,
  formKey,
  value,
  labelWeight,
  contentWeight,
}: {
  isEdit?: boolean;
  notEditable?: boolean; // true为不可编辑
  required?: boolean; // 是否必填
  label: string;
  formKey?: string;
  value?: string | number; // field.value为空时显示的value，一般用于只读数据
  labelWeight?: number; // label的flex占比
  contentWeight?: number; // content的flex占比
}) => {
  const { prefix, classname } = usePrefix('bicester-card-item');

  const { data: allCities, loading } = useAllCities();

  return (
    <div className="bicester-card-item-wrap">
      <FormGroup className={`${classname} bicester-card-citypicker`}>
        <ControlLabel
          className={prefix('label')}
          style={{ ...(labelWeight && { flex: labelWeight }) }}
        >
          <div className={prefix('label-text')}>{label}</div>
          <div
            className={`${prefix('label-divider')} ${isEdit && required ? 'required' : ''}`}
          ></div>
        </ControlLabel>
        <div
          className={`${prefix('content-wrap')} ${isEdit ? prefix('content-wrap-isedit') : ''}`}
          style={{ ...(contentWeight && { flex: contentWeight }) }}
        >
          {isEdit && !notEditable ? (
            <FormControl
              className={prefix('content')}
              name={formKey}
              accepter={Cascader}
              data={allCities}
              {...(loading && { renderMenu: () => <PageLoader /> })}
            />
          ) : (
            <FormControl
              name={formKey}
              accepter={({ field }) => (
                <div className={prefix('content-wrap-text')}>
                  {getConcatCity(field.value, allCities) || value || FORM_DEFAULT_DISPLAY}
                </div>
              )}
            />
          )}
        </div>
      </FormGroup>
    </div>
  );
};

export default BicesterCardCityPicker;
